import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HomepageLinksService {
  readonly home: string;
  readonly terms: string;
  readonly privacy: string;
  readonly pricing: string;

  constructor() {
    const { host } = window.location;

    const origin =
      host === 'localhost:3000' || host === 'localhost:4200'
        ? 'http://localhost:5500/'
        : host === 'app.devsandpit.com'
        ? 'https://devsandpit.com/'
        : 'https://fociva.com/';

    this.home = origin + '#home';
    this.terms = origin + 'terms.html';
    this.privacy = origin + 'privacy.html';
    this.pricing = origin + 'pricing.html';
  }
}
